import { SessionDimensions, SessionMetrics, useSessionMetrics } from '@va/dashboard/api-client/sessions.api';
import { Where } from '@va/types/filters';
import { Sorting } from '@va/types/requests';

type Query<T extends string = string> = {
  pagination: { page: number; pageSize: number };
  where?: Where;
  order?: Sorting<T>[];
};

const COUNTRY_DIMENSIONS = ['countryCode'] satisfies SessionDimensions[];
const CITY_DIMENSIONS = ['cityName', 'countryCode'] satisfies SessionDimensions[];
const METRICS = ['sessionCount', 'sessionPercentOfTotal'] satisfies SessionMetrics[];

export const useSessionsByCountry = (query: Query<(typeof METRICS)[number]>) => {
  return useSessionMetrics({
    trace: COUNTRY_DIMENSIONS[0],
    dimensions: COUNTRY_DIMENSIONS,
    metrics: METRICS,
    ...query,
  });
};

export const useSessionsByCity = (query: Query<(typeof METRICS)[number]>) => {
  return useSessionMetrics({
    trace: CITY_DIMENSIONS[0],
    dimensions: CITY_DIMENSIONS,
    metrics: METRICS,
    ...query,
  });
};
